<template>
  <div style="text-align: left; padding-bottom: 24px;">
    <div v-if="user" class="user-info text-align-left" style="    display: flex;
    justify-content: left;
    align-items: center;">
      <div class="user-avatar small ml-0 mr-0">
        <img :src="user.photoURL" v-if="user.photoURL" />
        <i v-if="!user.photoURL" class="stg st-single-neutral-circle-2" />
      </div>
      <div class="user-information pl-3"> <b class="text-black">{{user.name}}</b></div>
    </div>
    <div class="mt-1 text-black">{{message}}</div>
  </div>
</template>

<script>
export default {
  props: ["userRef", "message"],
  data: function() {
    return {
      user: null
    };
  },

  mounted: function() {
    let $this = this;
    this.userRef
      .get()
      .then(function(querySnapshot) {
        $this.user = querySnapshot.data();
      })
      .catch(function(error) {
        console.log("Error getting documents: ", error);
      });
  }
};
</script>

<style>
</style>